module.exports = __webpack_public_path__ + "img/icon_map_11_on_110.fd12c249.png";